import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicIcon from "../components/DynamicIcon";
import { getProductCategoriesList, getProductCategoriesTree, getProductCategoryDetail, resetSelectedCategory, selectProductCategoriesList, selectProductCategoriesLoading, selectProductCategoriesTree, selectProductCategoriesTreeLoading } from "../redux/productCategory/productCategorySlice";
import { getProductDetails, resetProductDetails } from "../redux/products/productsSlice";
import { selectAccountData } from "../redux/main/accountSlice";
import { resetRefreshNow, selectRightModalId, selectRightModalIsOpen, selectRightModalIsRefreshNow, selectRightModalmode, setModal } from "../redux/rightModalSlice";
import LoadingSection from "../components/LoadingSection";
import DynamicTitle from "../components/DynamicTitle";
import CategoryTree from "../components/productCategoryPage/CategoryTree";
import RightModal from "../components/templates/RightModal";
import AddEditCategory from "../components/productCategoryPage/AddEditCategory";
import ViewCategory from "../components/productCategoryPage/ViewCategory";
import AddEditProduct from "../components/productsPage/AddEditProduct";

export default function ProductCategoriesList() {
    const dispatch = useDispatch();
    const categoriesList = useSelector(selectProductCategoriesList);
    const categoriesLoading = useSelector(selectProductCategoriesLoading);
    const categoriesTree = useSelector(selectProductCategoriesTree);
    const categoriesTreeLoading = useSelector(selectProductCategoriesTreeLoading);
    const accountData = useSelector(selectAccountData);
    const token = localStorage.getItem('installamelo-auth-token');

    // Contatore per forzare il refresh dei prodotti inline nel tree
    const [productsRefreshKey, setProductsRefreshKey] = useState(0);

    // RightModal gestita tramite Redux
    const rightModalIsOpen = useSelector(selectRightModalIsOpen);
    const rightModalMode = useSelector(selectRightModalmode);
    const rightModalCategoryId = useSelector(selectRightModalId);

    // Carica le categorie quando il componente viene montato
    useEffect(() => {
        if (accountData?._id) {
            dispatch(getProductCategoriesTree({
                accountId: accountData._id,
                token
            }));
            dispatch(getProductCategoriesList({
                accountId: accountData._id,
                token
            }));
        }
    }, [dispatch, accountData]);

    // Avvio il refresh dei dati quando isRefreshNow della RightModal si attiva
    const rightModalIsRefreshNow = useSelector(selectRightModalIsRefreshNow);
    useEffect(() => {
        if (rightModalIsRefreshNow && accountData?._id) {
            dispatch(getProductCategoriesTree({
                accountId: accountData._id,
                token
            }));
            dispatch(getProductCategoriesList({
                accountId: accountData._id,
                token
            }));
            // Incrementa il contatore per refreshare i prodotti inline nel tree
            setProductsRefreshKey(prev => prev + 1);
            dispatch(resetRefreshNow());
        }
    }, [rightModalIsRefreshNow, dispatch, accountData]);

    // Carica i dettagli della categoria quando il modale viene aperto per modifica o visualizzazione
    useEffect(() => {
        if (rightModalIsOpen && rightModalCategoryId && (rightModalMode === 'edit' || rightModalMode === 'view')) {
            dispatch(getProductCategoryDetail({
                categoryId: rightModalCategoryId,
                token
            }));
        }
    }, [rightModalIsOpen, rightModalCategoryId, rightModalMode, dispatch, token]);

    // Carica i dettagli del prodotto quando il modale viene aperto per modifica prodotto
    useEffect(() => {
        if (rightModalIsOpen && rightModalCategoryId && rightModalMode === 'editProduct') {
            dispatch(getProductDetails({
                productId: rightModalCategoryId,
                token
            }));
        }
    }, [rightModalIsOpen, rightModalCategoryId, rightModalMode, dispatch, token]);

    // Reset quando si chiude il modale
    useEffect(() => {
        if (!rightModalIsOpen) {
            dispatch(resetSelectedCategory());
            dispatch(resetProductDetails());
        }
    }, [rightModalIsOpen, dispatch]);

    // Callback per drag & drop prodotto tra categorie
    const handleProductMoved = () => {
        setProductsRefreshKey(prev => prev + 1);
    };

    // Gestisce il click sul bottone di nuova categoria
    const handleAddCategory = () => {
        dispatch(resetSelectedCategory());
        dispatch(setModal({
            mode: 'add',
            percentuageWidth: 40
        }));
    };

    return (
        <div className="page">
            {(categoriesLoading || categoriesTreeLoading) && <LoadingSection isFixed />}
            <DynamicTitle title="Categorie Prodotti" />

            <h1>Categorie Prodotti</h1>

            <div className="flex justify-end mb-4">
                <button
                    className="primary"
                    onClick={handleAddCategory}
                >
                    <DynamicIcon iconClass="fa-solid fa-plus" />
                    Nuova Categoria
                </button>
            </div>

            <div className="box">
                <CategoryTree categories={categoriesTree} productsRefreshKey={productsRefreshKey} onProductMoved={handleProductMoved} />
            </div>

            {/* RIGHT MODAL per inserimento, modifica o visualizzazione */}
            {
                rightModalIsOpen && (
                    <RightModal>
                        {rightModalMode === 'add' && (
                            <AddEditCategory mode="add" />
                        )}
                        {rightModalMode === 'edit' && rightModalCategoryId && (
                            <AddEditCategory mode="edit" />
                        )}
                        {rightModalMode === 'view' && rightModalCategoryId && (
                            <ViewCategory />
                        )}
                        {rightModalMode === 'editProduct' && rightModalCategoryId && (
                            <AddEditProduct mode="edit" />
                        )}
                    </RightModal>
                )
            }
        </div>
    );
}
